var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 12.7461C16.1087 12.7461 16.5326 12.5686 16.8452 12.2529C17.1577 11.9371 17.3333 11.5088 17.3333 11.0622V1.80104C17.3333 1.35445 17.1577 0.926158 16.8452 0.610375C16.5326 0.294592 16.1087 0.117188 15.6667 0.117188H6.88333C7.175 0.630761 7.33333 1.21169 7.33333 1.80104H15.6667V11.0622H8.16667V12.7461H15.6667ZM11.5 4.32681V6.01066H6.5V16.9557H4.83333V11.9041H3.16667V16.9557H1.5V10.2203H0.25V6.01066C0.25 5.56407 0.425595 5.13578 0.738155 4.82C1.05072 4.50421 1.47464 4.32681 1.91667 4.32681H11.5ZM5.66667 1.80104C5.66667 2.24762 5.49107 2.67591 5.17851 2.9917C4.86595 3.30748 4.44203 3.48489 4 3.48489C3.55797 3.48489 3.13405 3.30748 2.82149 2.9917C2.50893 2.67591 2.33333 2.24762 2.33333 1.80104C2.33333 1.35445 2.50893 0.926158 2.82149 0.610375C3.13405 0.294592 3.55797 0.117188 4 0.117188C4.44203 0.117188 4.86595 0.294592 5.17851 0.610375C5.49107 0.926158 5.66667 1.35445 5.66667 1.80104Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutors);
export default __webpack_public_path__ + "static/media/tutors.1335547d.svg";
export { ForwardRef as ReactComponent };